var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 28,
    viewBox: "0 0 48 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 28,
    rx: 7,
    fill: "#FDE8E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2292 8.3125H21.0833C21.1635 8.3125 21.2292 8.24687 21.2292 8.16667V8.3125ZM21.2292 8.3125H26.7708V8.16667C26.7708 8.24687 26.8365 8.3125 26.9167 8.3125H26.7708V9.625H28.0833V8.16667C28.0833 7.52318 27.5602 7 26.9167 7H21.0833C20.4398 7 19.9167 7.52318 19.9167 8.16667V9.625H21.2292V8.3125ZM30.4167 9.625H17.5833C17.2607 9.625 17 9.88568 17 10.2083V10.7917C17 10.8719 17.0656 10.9375 17.1458 10.9375H18.2469L18.6971 20.4714C18.7263 21.093 19.2404 21.5833 19.862 21.5833H28.138C28.7615 21.5833 29.2737 21.0948 29.3029 20.4714L29.7531 10.9375H30.8542C30.9344 10.9375 31 10.8719 31 10.7917V10.2083C31 9.88568 30.7393 9.625 30.4167 9.625ZM27.9977 20.2708H20.0023L19.5612 10.9375H28.4388L27.9977 20.2708Z",
    fill: "#C7120F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillDeleteIcon);
export default __webpack_public_path__ + "static/media/skill-delete-icon.d39b26c64c9da183a1c0179b8864106a.svg";
export { ForwardRef as ReactComponent };